import { addYears } from 'date-fns';

import { EMPLOYEE_SAVINGS_RETIREMENT_AGE } from '@Common/constants/employee_savings';

import { type DateString, tryToDateString, tryToLocalDate } from '@sh4res/bo-common/utils/date';

export const wideInputStyle = { width: '100%' };

/** Retirement date (YYYY-MM-DD) derived from the date of birth, or null if it is not set. */
export const getDefaultRetirementDate = (
  dateOfBirth: unknown,
  retirementAge: number = EMPLOYEE_SAVINGS_RETIREMENT_AGE,
): DateString | null => {
  const dob = tryToLocalDate(dateOfBirth);
  return dob ? tryToDateString(addYears(dob, retirementAge)) : null;
};
